import { combineReducers } from 'redux';

import signalR from './signalR';
import productionOrders from './productionOrders';
import user from './user';
import machineOperation from './machineOperation';
import imageHandling from './imageHandling';
import list from './list';
import uploadQueue from './uploadQueue';
import notification from './notification';
import device from './device';
import time from './time';
import manufacture from './manufacture';
import membership from './membership';
import connector from './connector';
import logs from './logs';
import ticket from './ticket';
import parts from './parts';
import tools from './tools';
import clampingTools from './clampingTools';
import machines from './machines';
import images from './images';
import fileConnector from './fileConnector';
import blobStorage from './blobStorage';
import onBoarding from './onBoarding';
import onboardingWizard from './onboardingWizard';
import dynamicConfig from './dynamicConfig';
import globalAdd from './globalAdd';
import colors from './colors';
import statistics from './statistics';
import details from './details';
import machinesV2 from './machinesV2';
import header from './header';
import params from './params';
import batch from './batch';
import language from './language';
import search from './search';

import productionConnectorSetup from '@components/settings/v2/structure/connector/productionConnectorSetup/reducer';
import operatorPanel from './operatorPanel';
import retrieveQueue from './retrieveQueue';
import imageHandlingV2 from './v2/imageHandlingV2/imageHandlingV2.slice';
import planboard from './v2/planboard';
import messagesBus from './v2/messagesBus/messagesBus.slice';
import annotationsV2 from './v2/annotationsV2/annotationsV2.slice';
import tableAccordion from './v2/tableAccordion/tableAccordion.slice';
import bottomSheet from './v2/bottomSheet/bottomSheet.slice';
import dashboard from './v2/dashboard/dashboard.slice';

const rootReducer = combineReducers({
  productionConnectorSetup,
  statistics,
  colors,
  dynamicConfig,
  onBoarding,
  onboardingWizard,
  blobStorage,
  fileConnector,
  images,
  user,
  signalR,
  notification,
  device,
  productionOrders,
  machineOperation,
  imageHandling,
  list,
  uploadQueue,
  time,
  manufacture,
  membership,
  connector,
  logs,
  ticket,
  parts,
  tools,
  clampingTools,
  machines,
  globalAdd,
  details,
  machinesV2,
  header,
  params,
  batch,
  language,
  search,
  operatorPanel,
  retrieveQueue,
  imageHandlingV2,
  planboard,
  messagesBus,
  annotationsV2,
  tableAccordion,
  bottomSheet,
  dashboard,
});

export default rootReducer;
